// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */

import React from 'react';
import classNames from '@ta/common.classnames';
import { useLocalize } from '@ta/platform.i18n';
import BackButton from './BackButton';
import SkipButton from './SkipButton';
import styles from './NavBar.css';

type Props = {|
  /** If true, a close button is shown instead of a back button */
  isFirstStep: boolean,

  /** If true, enable the back/close button */
  canGoBack: boolean,

  /**
   * If true, enable the skip button. This is generally true if the curren step is optional and
   * hasn't been filled out yet.
   */
  canSkip: boolean,

  /**
   * True to apply a scrolled style to the navbar so content that scrolls behind it doesn't overlap
   * with the buttons
   */
  isScrolled: boolean,

  onClose: () => mixed,
  onBack: () => mixed,
  onSkip: () => mixed,
|};

/**
 * A fixed top navigation bar
 */
const NavBar = ({
  isFirstStep,
  canGoBack,
  canSkip,
  isScrolled,
  onClose,
  onBack,
  onSkip,
}: Props) => {
  const { localize } = useLocalize();
  return (
    <div className={classNames(styles.navBar, { [styles.withBackground]: isScrolled })}>
      {isFirstStep ? (
        /* Close button - only active on the first screen */
        <BackButton
          iconName="times"
          label={localize.string('common_Close') /* Close */}
          disabled={!canGoBack}
          onClick={onClose}
        />
      ) : (
        /* Back button - only active after the first screen */
        <BackButton
          iconName="arrow-left"
          label={localize.string('reg_back') /* Back */}
          disabled={!canGoBack}
          onClick={onBack}
        />
      )}

      {/* Show a "SKIP" button if the current screen isn't fully completed but we can go forward */}
      <SkipButton disabled={!canSkip} onClick={onSkip} />
    </div>
  );
};

export default NavBar;
